import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { IoIosCloseCircleOutline } from "react-icons/io";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { message } from "antd";
import axios from "axios";
import { API_URL } from "./Api/Config";
import { Checkbox } from "antd";
import { MdOutlineDeleteForever } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { Switch } from "antd";
import { TbPasswordUser } from "react-icons/tb";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const SubAdmins = () => {
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    accessTabs: [],
    roleName: "subadmin",
  });

  const [isEdit, setIsEdit] = useState({
    edit: false,
    id: "",
  });

  const [ogData, setOgData] = useState([]);

  const [passOpen,setPassOpen]=useState(false)
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setIsEdit({
      id: "",
      edit: false,
    });
    setData({
      name: "",
      email: "",
      password: "",
      accessTabs: [],
      roleName: "subadmin",
    });
  };

  const postSubAdmin = async () => {
    try {
      const token = localStorage.getItem("dashtoken");
      if (!token) {
        localStorage.clear();
        message.error("Login required!");
        return;
      }

      if (
        data.name === "" ||
        data.email === "" ||
        data.password === "" ||
        data.accessTabs.length === 0
      ) {
        message.error("Required all fields!");
        return;
      }

      await axios.post(`${API_URL}/api/subadmin/auth/create`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      message.success("Added SuccessFully!");
      setOpen(false);
      await getAllSubAdmin();
      setData({
        name: "",
        email: "",
        password: "",
        accessTabs: [],
        roleName: "subadmin",
      });
    } catch (error) {
      console.log(error);
      message.error("Something went wrong!");
    }
  };

  const getAllSubAdmin = async () => {
    try {
      const token = localStorage.getItem("dashtoken");
      if (!token) {
        localStorage.clear();
        message.error("Login required!");
        return;
      }
      const res = await axios.get(`${API_URL}/api/subadmin`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.subadmins.length > 0) {
        setOgData(res.data.subadmins);
      } else {
        setOgData([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem("dashtoken");
      if (!token) {
        localStorage.clear();
        message.error("Login required!");
        return;
      }

      await axios.delete(`${API_URL}/api/subadmin/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      message.success("Deleted Successfully!");
      await getAllSubAdmin();
    } catch (error) {
      console.log(error);
      message.error("Something went wrong!");
    }
  };

  const updateSubAdmin = async (id, value) => {
    try {
      const token = localStorage.getItem("dashtoken");
      if (!token) {
        localStorage.clear();
        message.error("Login required!");
        return;
      }

      await axios.patch(
        `${API_URL}/api/subadmin/${id}`,
        { isActive: !value },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      message.success("Updated SuccessFully!");
      setData({
        name: "",
        email: "",
        password: "",
        accessTabs: [],
        roleName: "subadmin",
      });

      await getAllSubAdmin();
    } catch (error) {
      console.log(error);
      message.error("Something went wrong!");
    }
  };

  const handleEdit = (val) => {
    setData(val);
    setOpen(true);
    setIsEdit({ edit: true, id: val._id });
  };

  const hanldeUpdate = async () => {
    try {
      const token = localStorage.getItem("dashtoken");
      if (!token) {
        localStorage.clear();
        message.error("Login required!");
        return;
      }

      await axios.patch(`${API_URL}/api/subadmin/${isEdit.id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      message.success("Updated successfully!");
      setOpen(false);
      await getAllSubAdmin();
      setData({
        name: "",
        email: "",
        password: "",
        accessTabs: [],
        roleName: "subadmin",
      });
    } catch (error) {
      console.log(error);
      message.error("Something went wrong!");
    }
  };

  const [updateId,setUpdateId]=useState("")
  const [updatePass,setUpdatePass]=useState({
    newPassword:""
  })
  const handleUpdatePassword = async () => {
    try {
      const token = localStorage.getItem("dashtoken");
      if (!token) {
        localStorage.clear();
        message.error("Login required!");
        return;
      }

      await axios.patch(`${API_URL}/api/subadmin/auth/updatePassword/${updateId}`, {newPassword:updatePass.newPassword}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      message.success("Password Updated successfully!");
      setPassOpen(false);
      await getAllSubAdmin();
    
    } catch (error) {
      console.log(error);
      message.error("Something went wrong!");
    }
  };

  const handleUpdatePass=(id)=>{
    setUpdateId(id)
    setPassOpen(true)
  }



  useEffect(() => {
    getAllSubAdmin();
  }, []);

  return (
    <>
      <section className="mx-3">
        <Container>
          <div className="py-4 d-flex justify-content-between align-items-center">
            <div className="col-lg-6">
              <h1 className="h1">Sub Admin</h1>
            </div>
            <div className="col-lg-6 text-end">
              <Button
                varient="contained"
                onClick={handleOpen}
                className="filter-btn"
              >
                Create New
              </Button>
            </div>
          </div>
          <div>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell className="tableHead">S.No</TableCell>
                    <TableCell className="tableHead">Name</TableCell>
                    <TableCell className="tableHead">Email</TableCell>
                    <TableCell className="tableHead">IsActive</TableCell>
                    <TableCell className="tableHead">Update Pass</TableCell>
                    <TableCell className="tableHead">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ogData.length > 0 &&
                    ogData.map((val, i) => (
                      <TableRow
                        key={i}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row" className="">
                          {i + 1}
                        </TableCell>
                        <TableCell className="">{val.name || "-"}</TableCell>
                        <TableCell className="">{val.email || "-"}</TableCell>
                        <TableCell className="">
                          <Switch
                            value={val.isActive}
                            onChange={() =>
                              updateSubAdmin(val._id, val.isActive)
                            }
                          />
                        </TableCell>
                        <TableCell><a onClick={()=>handleUpdatePass(val._id)} style={{cursor:"pointer"}}><TbPasswordUser style={{fontSize:"20px"}}/>Password</a></TableCell>
                        <TableCell className="">
                          <MdEdit
                            className="me-3"
                            style={{
                              fontSize: "18px",
                              color: "green",
                              cursor: "pointer",
                            }}
                            onClick={() => handleEdit(val)}
                          />
                          <MdOutlineDeleteForever
                            style={{
                              fontSize: "20px",
                              color: "red",
                              cursor: "pointer",
                            }}
                            onClick={() => handleDelete(val._id)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Container>
      </section>

      {/* create subadamin model */}

      <div>
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="d-flex justify-content-between align-items-center">
              <h3>{isEdit.edit ? "Edit" : "Create New"} Sub Admin</h3>
              <IoIosCloseCircleOutline
                style={{ fontSize: "20px", cursor: "pointer" }}
                onClick={handleClose}
              />
            </div>
            <div>
              <label>
                Name: <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <input
                value={data.name}
                className="create-input p-1"
                onChange={(e) => setData({ ...data, name: e.target.value })}
              />
              <br />
              <label>
                Email: <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <input
                value={data.email}
                className="create-input p-1"
                onChange={(e) => setData({ ...data, email: e.target.value })}
              />
              {!isEdit.edit && (
                <>
                  <br />
                  <label>
                    Password: <span style={{ color: "red" }}>*</span>
                  </label>
                  <br />
                  <input
                    value={data.password}
                    className="create-input p-1"
                    onChange={(e) =>
                      setData({ ...data, password: e.target.value })
                    }
                  />
                </>
              )}
              <br />
              <label>
                Access: <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <Checkbox.Group
                value={data.accessTabs}
                onChange={(checkedValues) =>
                  setData({ ...data, accessTabs: checkedValues })
                }
              >
                <div className="d-flex flex-wrap gap-2">
                  <Checkbox value="/products">Products</Checkbox>
                  <Checkbox value="/orders">Orders</Checkbox>
                  <Checkbox value="/banners">Banners</Checkbox>
                  <Checkbox value="/business-with-us">
                    Business with us
                  </Checkbox>
                  <Checkbox value="/transaction">Transcation</Checkbox>
                  <Checkbox value="/franchies">Franchies</Checkbox>
                  <Checkbox value="/requirement">Requirement</Checkbox>
                  <Checkbox value="/customer">Customer</Checkbox>
                  <Checkbox value="/reports">Reports</Checkbox>
                </div>
              </Checkbox.Group>

              <div className="py-3 text-center">
                <Button
                  variant="contained"
                  className="add-btn"
                  onClick={isEdit.edit ? hanldeUpdate : postSubAdmin}
                >
                  {isEdit.edit ? "Update" : "Add"}
                </Button>
              </div>
            </div>
          </Box>
        </Modal>
      </div>



      {/* Update PASS */}
      <div>
        <Modal
          open={passOpen}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="d-flex justify-content-between align-items-center">
              <h3>Update Password</h3>
              <IoIosCloseCircleOutline
                style={{ fontSize: "20px", cursor: "pointer" }}
                onClick={()=>setPassOpen(false)}
              />
            </div>
            <div>
              <label>New Password</label><br />
              <input style={{width:"100%",height:35}} value={updatePass.newPassword} onChange={(e)=>setUpdatePass({...updatePass,newPassword:e.target.value})}/>
                <div className="text-center py-4" >
                  <Button variant="contained" onClick={handleUpdatePassword}>Update</Button>
                </div>
            </div>
          
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default SubAdmins;
